<template>
  <div class="ksm-home__page-wrapper">
    <div class="ksm-home__page-bg"></div>
    <div class="ksm-home__page">
      <div class="ksm-home__content" v-html="$_getSvg('schwitters_startseite.svg')"></div>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
export default {
  data() {
    return {
      rectImages: [
        {
          path: "merzwerbe",
          src: "startseite-merzw.jpg"
        },
        {
          path: "texte/ursonate",
          src: "startseite-film.jpg"
        },
        {
          path: "texte/merzhefte",
          src: "startseite-texte.jpg"
        }
      ],
      links: [
        "/schwitters",
        "/schwitters",
        "",
        "/orteundwege",
        "/merzwerbe",
        "/texte/ursonate",
        "/texte/merzhefte",
        "/personen",
        "/kunstwerke",
        "/orteundwege",
        "/orteundwege",
        "/orteundwege"
      ]
    };
  },
  mounted: function() {
    this.svg = this.$el.querySelector(".ksm-home__content svg");
    this.addJpg();
    this.addLinks();
  },
  methods: {
    addJpg() {
      const vue = this;
      const bildrahmen = this.svg.querySelector("#bildrahmen");
      const rects = bildrahmen.querySelectorAll("rect");
      const rectImages = this.rectImages;
      let i = 0;
      for (let rect of rects) {
        const $rect = d3.select(rect);
        d3.select(bildrahmen)
          .append("image")
          .attr("xlink:href", "static/icons/" + rectImages[i].src)
          .attr("x", $rect.attr("x"))
          .attr("y", $rect.attr("y"))
          .attr("data-path", rectImages[i].path)
          .attr("class", "ksm-home-img")
          .attr("width", $rect.attr("width"))
          .attr("height", $rect.attr("height"))
          .on("click", function() {
            const path = this.getAttribute("data-path");
            vue.$router.push(path);
          });
        i++;
      }
    },

    addLinks() {
      const gs = this.svg.querySelectorAll("#text > g");
      const links = this.links;
      let i = 0;
      const vue = this;
      for (let g of gs) {
        g.classList.add("ksm-home-g");
        const box = g.getBBox();
        const rect = d3
          .select(g)
          .append("rect")
          .attr("x", box.x)
          .attr("y", box.y)
          .attr("width", box.width)
          .attr("height", box.height)
          .attr("data-linkIdx", i)
          .attr("class", function() {
            const idx = this.getAttribute("data-linkIdx");
            if (links[idx]) {
              return "ksm-home__rect-wrapper";
            } else {
              g.classList.remove("ksm-home-g");
              return "ksm-home__rect-wrapper-nolink";
            }
          })
          .on("click", function() {
            const idx = this.getAttribute("data-linkIdx");
            if (links[idx]) {
              vue.$router.push({
                path: links[idx]
              });
            }
          });
        i++;
      }
    }
  }
};
</script>

<style lang="scss">
$textColor: rgb(75, 129, 130);
$titleBg: rgb(197, 214, 213);
.ksm-home__page-wrapper {
  @extend .ksm-flex-x-center;
  @extend .ksm-flex-1;
  padding: 60px;
  position: relative;
}

.ksm-home__page-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.ksm-home__page {
  z-index: 100;
  max-width: 1400px;
  @extend .ksm-flex-xy-center;
  position: relative;
  width: 100%;
  height: 100%;

  .ksm-home__content {
    @extend .ksm-flex-xy-center;
    top: 0px;
    left: 0px;
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 35px;
    svg {
      height: 100%;
      width: 100%;
    }
  }
}

.ksm-home-img {
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
}

.ksm-home-g {
  &:hover {
    * {
      opacity: 0.93;
    }
  }
}

.ksm-home__rect-wrapper {
  fill: transparent;
  &:hover {
    // stroke: $lightGrey;
    // stroke-width: 1px;
    cursor: pointer;
  }
}
.ksm-home__rect-wrapper-nolink {
  fill: transparent;
}
</style>


// WEBPACK FOOTER //
// Home.vue?39f8bca6